import cherryBlossomSystem from './particleSystems/cherryBlossomSystem'
import rainSystem from './particleSystems/rainSystem'
import cloudSystem from './particleSystems/cloudSystem'
import smokeSystem from './particleSystems/smokeSystem'
import fallSystem from './particleSystems/fallSystem'
import springSystem from './particleSystems/springSystem'
import fireSystem from './particleSystems/fireSystem'
import fireCenteredSystem from './particleSystems/fireCenteredSystem'
import sandSystem from './particleSystems/sandSystem'
import snowSystem from './particleSystems/snowSystem'

const systems = [
  {
    id: 'cherryBlossom',
    data: cherryBlossomSystem,
    name: 'Cherry Blossom Petals',
  },
  {
    id: 'cloud',
    data: cloudSystem,
    name: 'Clouds',
  },
  {
    id: 'spring',
    data: springSystem,
    name: 'Leaves (Spring)',
  },
  {
    id: 'fall',
    data: fallSystem,
    name: 'Leaves (Fall)',
  },
  {
    id: 'fire',
    data: fireSystem,
    name: 'Fire',
  },
  {
    id: 'fireCentered',
    data: fireCenteredSystem,
    name: 'Fire (from Center)',
  },
  {
    id: 'rain',
    data: rainSystem,
    name: 'Rain',
  },
  {
    id: 'sand',
    data: sandSystem,
    name: 'Desert / Sand',
  },
  {
    id: 'smoke',
    data: smokeSystem,
    name: 'Smoke',
  },
  {
    id: 'snow',
    data: snowSystem,
    name: 'Snow',
  },
]

export default systems
